import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import DashboardNavbar from "../../shared/DashboardNavbar";
import GroupSummaryModal from "../modals/GroupSummaryModal";
import api from "../../../Api/api";

function GroupDetails() {
  const { groupId } = useParams();
  const navigate = useNavigate();
  const [group, setGroup] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteMsg, setInviteMsg] = useState("");
  const [members, setMembers] = useState([]);
  const [showSummary, setShowSummary] = useState(false);


  useEffect(() => {
    if (groupId) {
      localStorage.setItem("currentGroupId", groupId);
    }
  }, [groupId]);

  useEffect(() => {
    api.get(`/groups/${groupId}`)
      .then(res => {
        setGroup(res.data);
        setGroupName(res.data.name);
      })
      .catch(() => navigate("/dashboard"));

    api.get(`/groups/${groupId}/members`)
      .then(res => {
        setMembers(res.data);
      })
      .catch(err => console.error("Failed to load group members:", err));
  }, [groupId, navigate]);

//update group name
  const handleEdit = async (e) => {
    e.preventDefault();
    try {
      await api.patch('/groups/update', {
        name: groupName,
        groupId: parseInt(groupId)
      });
      setGroup(prev => ({ ...prev, name: groupName }));
      setEditMode(false);
      alert("Group name updated!");
    } catch (err) {
      alert("Error updating group");
    }
  };

  const handleDelete = async () => {
    await api.delete(`/groups/${groupId}`);
    alert("Group deleted!");
    navigate("/dashboard");
  };

  const handleInvite = async (e) => {
    e.preventDefault();
    try {
      await api.post('/groups/add-user', {
        groupId: parseInt(groupId),
        name: inviteEmail
      });

      setInviteMsg(`Invite sent to ${inviteEmail}!`);
      setInviteEmail("");
      
    } catch (err) {
      alert("Error inviting member");
    }
  };

  if (!group) return <div className="container mt-4">Loading group details...</div>;

  return (
    <>
      <DashboardNavbar />
      <div className="dashboard-card">
        <h2>
          👥{" "}
          {editMode ? (
            <form className="d-inline" onSubmit={handleEdit}>
              <input
                type="text"
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
                className="form-control d-inline w-auto"
                style={{ fontSize: "1.5rem" }}
              />
              <button type="submit" className="btn btn-sm btn-primary ms-2">Save</button>
              <button
                type="button"
                className="btn btn-sm btn-secondary ms-2"
                onClick={() => {
                  setEditMode(false);
                  setGroupName(group.name);
                }}
              >
                Cancel
              </button>
            </form>
          ) : (
            <>
              {group.name}{" "}
              <button
                className="btn btn-sm btn-outline-primary ms-2"
                onClick={() => setEditMode(true)}
              >
                Edit
              </button>
            </>
          )}
        </h2>

        <div className="mb-4">
          <button className="btn btn-danger" onClick={handleDelete}>
            Delete Group
          </button>
        </div>

        <div className="mb-3">
          <h5>Invite Member</h5>
          <form className="d-flex align-items-center" onSubmit={handleInvite}>
            <input
              type="email"
              className="form-control me-2"
              placeholder="Enter email"
              value={inviteEmail}
              onChange={(e) => setInviteEmail(e.target.value)}
              required
            />
            <button type="submit" className="btn btn-success">Invite</button>
          </form>
          {inviteMsg && <div className="alert alert-info mt-2">{inviteMsg}</div>}
        </div>
        <div className="mt-4">
          <h5>👨‍👩‍👧‍👦 Group Members</h5>
          <ul className="list-group">
            {members.map((member, index) => (
              <li key={index} className="list-group-item">
                <strong>{member.name}</strong> - {member.email}
              </li>
            ))}
          </ul>
          {members.length === 0 && <p className="text-muted">No members yet.</p>}
        </div>
      </div>
      <div className="dashboard-card mt-4">
        <button className="btn btn-outline-primary me-2" onClick={() => setShowSummary(true)}>
          View Group Summary
        </button>
      </div>
      {showSummary && <GroupSummaryModal groupId={groupId} onClose={() => setShowSummary(false)} />}
    </>
  );
}

export default GroupDetails;
